<template>
  <van-popup v-model="show" class="popup">
    <div class="layout">
      <img class="close" src="../assets/close.svg" @click="close" />
      <div class="content">
        <div class="title" v-html="title"></div>
        <div class="inner-content">
          <div class="sub-title" v-html="subTitle"></div>
          <p class="desc" v-html="content"></p>
        </div>
        <img class="icon" :src="icon" />
      </div>
      <button @click="click">{{ buttonText }}</button>
    </div>
  </van-popup>
</template>
<script>
import Vue from "vue";
import { Popup } from "vant";

Vue.use(Popup);
export default {
  data() {
    return {
      show: false,
    };
  },
  created() {
    this.show = this.value;
  },
  props: [
    "value",
    "title",
    "subTitle",
    "icon",
    "content",
    "buttonText",
    "buttonClick",
    "closeClick",
  ],
  watch: {
    show(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.show = val;
    },
  },
  methods: {
    close(e) {
      this.show = false;
      this.$emit("closeClick",e);
    },
    click(e) {
      this.show = false;
      this.$emit("buttonClick",e);
    },
  },
};
</script>
<style lang="less" scoped>
.popup {
  background: transparent;
  min-width: 250px;
}
.layout {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.close {
  align-self: flex-end;
  width: 26px;
  height: 26px;
  margin-bottom: 24px;
}
.content {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  align-items: flex-start;
}
.icon {
  position: absolute;
  width: 90px;
  top: 10px;
  right: 20px;
}
.content::before {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  background: #1d1d1d;
  z-index: -1;
}
.title {
  font-family: "宋体";
  color: #f1dec0;
  font-size: 20px;
  margin-top: 32px;
  margin-left: 24px;
  margin-bottom: 12px;
}
.inner-content {
  background-image: url("../assets/alert_bg.png");
  padding: 24px;
  background-size: 100% 100%;

  .sub-title {
    font-size: 14px;
    color: #000;
    font-weight: 600;
  }
  .desc {
    font-size: 14px;
    color: #1d1d1d;
    font-weight: 400;
    line-height: 22px;
  }
}
button {
  width: 138px;
  height: 36px;
  background: linear-gradient(90deg, #e8c798, #ecd1bc);
  border-radius: 24px;
  outline: none;
  border: none;
  margin-top: 40px;
}
</style>
